import type { ServerResponse } from "node:http";

export function addCookieToResponse(res: ServerResponse, cookie: string) {
  const existingCookies = res.getHeader("Set-Cookie");
  const newCookies = existingCookies
    ? Array.isArray(existingCookies)
      ? [...existingCookies.map((c) => String(c)), cookie]
      : [String(existingCookies), cookie]
    : cookie;
  res.setHeader("Set-Cookie", newCookies);
}
